import styled from 'styled-components';
export const LeftHeadingDiv = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const WrapperDiv = styled.div`
  padding: 2rem 4rem;

  @media (max-width: 1440px) {
    padding: 2rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const ContainerDiv = styled.div`
  max-width: 1440px;
  margin-inline: auto;
`;
export const BodyBox = styled.div`
  background: White;
  border-radius: 0.25rem;
  border: 1px solid #cccccc;
  min-height: 150px;
  padding: 15px;
  margin-bottom: 15px;
`;
export const BodyBoxTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
`;
export const FilterBoxes = styled.div`
  display: grid;
  grid-template-rows: repeat(10, 30px);
  grid-template-columns: 150px 150px 150px;
  grid-gap: 5px;
`;

export const RemoveTag = styled.span`
  color: gray;
  cursor: pointer;
  font-size: 25px;
  margin: 0 5px;
  margin-top: -4px;
  float: left;
  &:after {
    display: inline-block;
    content: '\00d7';
  }
`;

export const TagContent = styled.span`
  float: right;
  margin: 7px 5px 7px 0px;
  padding-right: 8px;
  font-weight: 600;
  color: grey;
`;

export const LawmakerTag = styled.div`
  float: left;
  display: block !important;
  margin: 5px 0px !important;
  width: 180px;
`;

export const LawmakerContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  min-height: 100px;
`;

export const LawmakerLeft = styled.div`
  border-right: 1px solid #ced4da;
`;

export const LawmakerRight = styled.div`
  text-align: left;
  padding-left: 20px;
`;

export const LawmakerForm = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
`;

export const LawmakerFormGroup = styled.div`
  margin-bottom: 1rem;
  text-align: left;
  padding: 0 15px 0 0;
`;

export const LawmakerMessage = styled.div`
  color: red;
  font-size: 13px;
`;

export const LawmakerLabel = styled.label`
  display: inline-block;
  margin-bottom: 0.5rem;
  color: grey;
  font-weight: 600;
  font-size: 12px;
`;

export const LawmakerLabelOr = styled.div`
  display: inline-block;
  margin: 18px 0px !important;
  color: grey;
  font-weight: 600;
  font-size: 16px;
`;

export const LawmakerFormControl = styled.input`
  display: block;
  width: 99%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.8;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
`;

export const LawmakerButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 80px;
  height: 42px;
  margin-top: 6px;
  border: none;
  border-radius: 4px;
  background: gray;
  color: white;
  cursor: pointer;
`;


export const LawmakerCheckbox = styled.div`
  border: 1px solid #ced4da;
  height: 300px;
  border-radius: 4px;
  margin-bottom: 5px;
  overflow-y: scroll;
  padding: 15px;
`;

export const LawmakerCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const LawmakerChamberDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const CheckContainer = styled.label`
  display: block;
  position: relative;
  padding-left: 34px;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 12px;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border: 2px solid #cccccc;
    background: #fafafa;
    border-radius: 4px;
    box-shadow: inset 0px 2px 3px 0px #0000000d;
    transition: background 0.2s, border-color 0.2s;
  }

  &:hover input ~ span {
    background-color: #ffffff;
  }

  input:checked ~ span {
    background: #0a819f;
    border-color: #0a819f;
  }

  span::after {
    content: '';
    position: absolute;
    display: none;
  }

  input:checked ~ span::after {
    display: block;
    left: 5px;
    top: -1px;
    width: 6px;
    height: 12px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;

export const AccountInformationForm = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 25px;
  margin-block-start: 1rem;
`;

export const AccountInformationFormGroup = styled.div`
  text-align: left;
  padding: 0 15px 0 0;
`;

export const AccountInformationMessageError = styled.p`
  color: red;
  font-size: 13px;
  text-align: center;
  padding-bottom: 5px;
`;

export const AccountInformationMessageSuccess = styled.p`
  color: green;
  font-size: 13px;
  text-align: center;
  padding-bottom: 5px;
`;

export const AccountInformationLabel = styled.label`
  display: inline-block;
  margin-bottom: 0.5rem;
  color: #959595;
  font-weight: 500;
  font-size: 11px;

  span {
    color: red;
  }
`;

export const AccountInformationFormControl = styled.input`
  display: block;
  width: 99%;
  font-size: 14px;
  height: 35px;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;

  &:disabled {
    background-color: #ccc;
  }
`;

export const ButtonAccountInformation = styled.button`
  background-color: #4c4b4c;
  width: 33%;
  height: 35px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  color: #fff;
  font-weight: 600;
  margin: 25px 0 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AccountInformationSpinner = styled.div`
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ButtonChangePassword = styled.button`
  text-decoration: underline;
  font-weight: 600;
  font-size: 13px;
  float: right;
  cursor: pointer;
`;

export const LeftMenuHover = styled.div`
  &:hover {
    color: black;
  }
`;

export const MenuIcons = styled.div`
  margin-top: 1px;
  width: 18px !important;
  height: 18px !important;
`;

export const RemoveBtn = styled.button`
  width: 80px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background: #4c4b4c;
  color: white;
  cursor: pointer;
`;


